<template>
  <div class="questionnairePage" id="tinyScreenQuestionnaire">
    <Header></Header>
     <!-- banner -->
    <div class="bannerBox">
      <div class="container">
        <div class="storyTxt">
          <div v-if="lang == 'en'">
            <h5>{{bannerBox.enSubContent}}</h5>
            <span>{{bannerBox.enContent}}</span>
          </div>
          <div v-else>
            <h5>{{bannerBox.cnSubContent}}</h5>
            <span>{{bannerBox.cnContent}}</span>
          </div>
        </div>
        <img class="fr mt30" width="300px" :src="bannerBox.pcAdvertUrl">
      </div>
    </div>
    <div class="section1">
       <div class="container">
        <h4 class="title titleTxt">{{$t('questionnaire.title')}}</h4>
        <!-- <p class="subTitle">{{$t('questionnaire.subTitle')}}</p> -->
        <div class="selectBox">
          <el-select v-model="questionType" @change="changeId(questionType)" :placeholder="$t('questionnaire.placeholder')">
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="lang=='en'?item.typeEnName:item.typeName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <br>
        <div class="fromData" v-if="questionType">
          <el-form ref="form" :model="form" label-width="30px">
            <el-form-item v-for="(item,index) in questionList" :key="index" :label="index+1+'.'">
              <p>{{item.question}}</p>
              <el-radio-group v-model="item.score" @change="changeRadio(item.score,index)">
                <el-radio v-for="(n,i) in item.optionList" :key="i" :label="n.score">{{n.content}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">{{$t('questionnaire.submit')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
export default {
  data() {
    return {
      isShowSearch:false,
      isHover:false,
      questionType:null,
      score:0,
      form:{},
      questionList:[],
      lang:'',
       bannerBox:{
        pcAdvertUrl:'',
        mobileAdvertUrl:'',
        cnContent:'',
        cnSubContent:'',
        enContent: '',
        enSubContent: '',
      },
      typeList:[
        {
          typeEnName:'Personal investment',
          typeName:'个人投资',
          id:'1'
        },
        {
          typeEnName:'Institutional investment',
          typeName:'机构投资',
          id:'2'
        },
        {
          typeEnName:'Product investment',
          typeName:'产品投资',
          id:'3'
        }
      ],
    };
  },
  components: { Header,Footer },
  mounted(){
    this.lang = window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'cn';
    this.getAdvert();
  },
  methods: {
    changeId(id){
      this.getQuestionByQuestionType(id);
    },
     // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=14");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.bannerBox = {
          ...res.data[0]
        };
    },
    changeRadio(score,index){
      let total = 0;
      this.questionList.map(e=>{
        if(e.score){
          total = total+e.score;
        }
      })
      this.score = total;
    },
    // 根据问卷类型获取问卷列表
    async getQuestionByQuestionType(questionType) {
        const { data: res } = await this.$http.get("/question/getQuestionByQuestionType.do?questionType="+questionType);
        if (res.code !== 200) return this.$message.error(res.message);
        this.questionList = res.data;
    },
     // 根据问卷分数获取投资者类型
    async getQuestionStyleByScore() {
        const { data: res } = await this.$http.get("/question/getQuestionStyleByScore.do?score="+this.score); 
        if (res.code == 200){
          let type = res.data.styleName;
          let content = res.data.content;
           this.$alert('感谢您的提交，根据您的提交情况得出，您属于'+type+','+content, '答题结束', {
          confirmButtonText: '返回首页',
          confirmButtonClass:'confirmBtn',
          callback: action => {
              this.$router.push({  
                path: '/'
              }) 
            }
          });
        }else{
          this.$message.error(res.message);
        }
    },
    // 提交
    onSubmit() {
      this.getQuestionStyleByScore(this.score);
    }
  }
};
</script>

<style lang="less" scoped>
.questionnairePage{
  .el-message-box {
      color: #FFF;
      background-color: #900211;
      border-color: #900211;
    }
  .bannerBox{    
    width: 100%;
    height: 360px;
    background: #333333;
    display: flex;
    .storyTxt{
        display: inline-block;
        padding-top: 112px;
       h5{      
        font-size: 14px;
        /*font-family: PingFangSC-Medium, PingFang SC;*/
        font-weight: 100;
        color: #fff;
        line-height: 22px;
        margin-bottom: 36px;
      }
      span{
        font-size: 40px;
         font-weight: 100;
         color: #fff;
      }
       img{
        margin-top: 170px;
       }
    }
  }
  .section1{
    padding:120px 0 255px 0;
    /deep/ .el-radio__input.is-checked .el-radio__inner {
      border-color: #900211;
      background: #900211;
    }
    /deep/ .el-radio__inner{
      border: 1px solid #900211;
    }
    /deep/ .el-radio__input.is-checked+.el-radio__label{
      color:#900211;
    }
    .el-select{
      width: 100%;
    }
    .title{
      text-align: center;
      font-size: 35px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #900211;
      line-height: 49px;
      letter-spacing: 2px;
      margin-bottom: 63px;  
    }
    .subTitle{
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #353535;
      line-height: 20px;
      text-align: center;
      margin-bottom: 63px;
    }
    .selectBox{
      width: 50%;
      margin:0 auto;
      display: block;
    }
    .fromData{
      width: 60%;
      margin:0 auto;
      display: block;
      .el-radio-group{
        width: 100%;
        display: inline-block;
      }
      .el-radio{
        width: 100%;
        display: inline-block;
        border:1px #666 solid;
        padding:10px;
        margin-bottom: 10px;
      }
      .el-button--primary {
        color: #FFF;
        background-color: #900211;
        border-color: #900211;
      }
      
    }
  }
}
</style>
